module.exports = __webpack_public_path__ + "img/dynamicLogo1.8822f837.png";